import React, { useId } from "react";
import { useTranslation } from "react-i18next";

export default function PipelineShareControl({ value = "none", onChange, configured, eligible, canEdit = true, busy = false, spaceName, legacyManagement = false, savedValue = "none", pending = false }) {
  const { t } = useTranslation("benutzer");
  const hintId = useId();
  const controlId = useId();
  const reason = !canEdit ? "ownerOnly" : !eligible ? "requiresAccess" : legacyManagement && value === "manage" ? "legacyHint"
    : value === "manage" ? "manageHint" : configured == null ? "loading" : !configured ? "notConfigured" : "hint";
  const unavailable = option => option !== value && option !== savedValue
    && (!eligible || option === "use" && !configured);
  const disabled = busy || !canEdit || value === "none" && savedValue === "none" && !eligible;
  return <div className="pipeline-share-control" style={{ padding: "var(--iio-s-3)", borderTop: "1px solid var(--iio-border)", color: "var(--iio-text-2)", fontSize: 14, overflowWrap: "anywhere" }}>
    <label htmlFor={controlId} style={{ display: "block", color: "var(--iio-text-1)", fontWeight: 600, marginBottom: "var(--iio-s-2)" }}>
      {t("pipeline.label")}
    </label>
    <select id={controlId} value={value} onChange={e => onChange(e.target.value)} disabled={disabled}
      aria-label={t("pipeline.labelForSpace", { space: spaceName })} aria-describedby={hintId}
      style={{ width: "100%", minWidth: 0, minHeight: 44, marginBottom: "var(--iio-s-2)", padding: "var(--iio-s-2) 32px var(--iio-s-2) var(--iio-s-2)",
        fontFamily: "inherit", fontSize: "inherit", color: "var(--iio-text-1)", backgroundColor: "var(--iio-bg-1)",
        border: "1px solid var(--iio-border)", borderRadius: "var(--iio-r-sm)", opacity: disabled ? 0.6 : 1, cursor: disabled ? "not-allowed" : "pointer" }}>
      <option value="none">{t("pipeline.none")}</option>
      <option value="use" disabled={unavailable("use")}>{t("pipeline.use")}</option>
      <option value="manage" disabled={unavailable("manage")}>{t("pipeline.manage")}</option>
    </select>
    <div id={hintId} aria-live="polite">{busy ? t("pipeline.saving") : t(`pipeline.${reason}`)}</div>
    {pending && !busy && <div role="status" style={{ marginTop: "var(--iio-s-2)" }}>{t("pipeline.pending")}</div>}
  </div>;
}
